import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Badge, Button, Spinner, Alert } from 'react-bootstrap';
import bestDealService from '../services/bestDealService';

const BestDeals = () => {
  const [deals, setDeals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadDeals();
  }, []);

  const loadDeals = async () => {
    try {
      const response = await bestDealService.getActiveDeals();
      setDeals(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error loading deals:', error);
      setError('Failed to load deals');
      setLoading(false);
    }
  };

  const formatPrice = (price) => {
    if (!price) return '';
    return price.startsWith('$') ? price : `$${price}`;
  };

  if (loading) {
    return (
      <Container className="mt-5 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
        <h4 className="mt-3">Loading Best Deals...</h4>
      </Container>
    );
  }

  return (
    <Container className="mt-5">
      <Row>
        <Col>
          <h1 className="mb-4">
            <i className="fas fa-tags me-2"></i>
            Best Deals
          </h1>
          {error && <Alert variant="danger">{error}</Alert>}
        </Col>
      </Row>

      {deals.length === 0 ? (
        <Row>
          <Col>
            <Alert variant="info">
              <h4>No deals available</h4>
              <p>Check back later for amazing deals!</p>
            </Alert>
          </Col>
        </Row>
      ) : (
        <Row>
          {deals.map((deal) => (
            <Col key={deal.id} lg={6} xl={4} className="mb-4">
              <Card className="h-100 shadow-sm deal-card">
                {deal.imageUrl && (
                  <Card.Img 
                    variant="top" 
                    src={deal.imageUrl} 
                    alt={deal.title}
                    style={{ height: '200px', objectFit: 'cover' }}
                  />
                )}
                <Card.Body className="d-flex flex-column">
                  <Card.Title className="h5">{deal.title}</Card.Title>
                  
                  {deal.description && (
                    <Card.Text className="text-muted flex-grow-1">
                      {deal.description}
                    </Card.Text>
                  )}

                  <div className="price-section mb-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        {deal.price && (
                          <span className="h4 text-success mb-0">
                            {formatPrice(deal.price)}
                          </span>
                        )}
                        {deal.originalPrice && (
                          <span className="text-muted text-decoration-line-through ms-2">
                            {formatPrice(deal.originalPrice)}
                          </span>
                        )}
                      </div>
                      {deal.discountPercentage && (
                        <Badge bg="danger" className="fs-6">
                          {deal.discountPercentage}% OFF
                        </Badge>
                      )}
                    </div>
                  </div>

                  {deal.linkUrl && (
                    <Button 
                      variant="primary" 
                      href={deal.linkUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="mt-auto"
                    >
                      <i className="fas fa-external-link-alt me-2"></i>
                      View Deal
                    </Button>
                  )}
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      )}

      <style jsx>{`
        .deal-card {
          transition: transform 0.2s ease-in-out;
        }
        .deal-card:hover {
          transform: translateY(-5px);
        }
      `}</style>
    </Container>
  );
};

export default BestDeals;